import type { PdpNearbyStore } from '../../domain/models/PdpNearbyStore';
import type { PdpStoreForCustomization } from '../../domain/models/PdpStoreForCustomization';
import type {
  PdpNearbyStoreDto,
  PdpNearbyStoresResponseDto,
  PdpStoreForCustomizationDto,
} from '../dto/pdpStore.dto';

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function mapNearbyStoreDto(dto: PdpNearbyStoreDto, fallbackId?: string): PdpNearbyStore {
  const storeId = String(dto.storeId ?? dto.id ?? fallbackId ?? '');
  return {
    storeId,
    storeName: dto.storeName ?? '',
    storeAddress: dto.storeAddress ?? '',
    contactNumber: dto.contactNumber ?? '',
    cityName: dto.cityName ?? '',
  };
}

export function storeForCustomizationDtoToDomain(
  dto: PdpStoreForCustomizationDto
): PdpStoreForCustomization | null {
  if (!dto.storeName) return null;

  const allNearbyStores = (dto.allNearbyStores ?? []).map((store, index) =>
    mapNearbyStoreDto(store, String(index))
  );

  return {
    storeName: dto.storeName,
    contactNumber: dto.contactNumber ?? '',
    whatsappNumber: dto.whatsappNumber ?? '',
    isDirectContactAllowed: dto.isDirectContactAllowed ?? false,
    allNearbyStores,
  };
}

export function nearbyStoresDtoToDomain(dto: PdpNearbyStoresResponseDto): Record<string, PdpNearbyStore> {
  const storeDetails = dto.storeDetails;
  if (!storeDetails || !isObject(storeDetails)) return {};

  const result: Record<string, PdpNearbyStore> = {};
  for (const [key, value] of Object.entries(storeDetails)) {
    if (isObject(value)) {
      result[key] = mapNearbyStoreDto(value as PdpNearbyStoreDto, key);
    }
  }
  return result;
}
